import { dispatchEventWrapper } from '../event/event';
import getClosest from '../get-closest/get-closest';

export default function trackLink() {
    createTrackEvents('.js-track-link', document, (link) => {
        let linkName = getLinkName(link);
        dispatchEventWrapper(document, 'rc-track-link', {
            area: 'Internal Link',
            event: linkName,
            label: link.getAttribute('href')
        });
    });

    if (document.querySelector('footer')) {
        createTrackEvents('a', document.querySelector('footer'), (link) => {
            let linkName = getLinkName(link);
            dispatchEventWrapper(document, 'rc-footer-link-clicked', {
                area: 'Footer',
                event: 'Clicked',
                label: linkName
            });
        });
    }
}

function createTrackEvents(
    selector:string,
    context: HTMLElement | Document = document,
    cb: Function
) {
    const links = context.querySelectorAll(selector);
    if (links) {
        links.forEach((link) => {
            link.addEventListener('click', () => {
                if (link.nodeName !== 'A') link = getClosest(link, 'a');
                if (link && link.getAttribute('href')) {
                    cb(link);
                }
            });
        });
    }
}

function getLinkName(link) {
    if (link.getAttribute('title')) return link.getAttribute('title');

    if (link.querySelector('img')) {
        return link.querySelector('img').getAttribute('alt');
    }

    return link.innerText.trim();
}
